module.exports = __webpack_public_path__ + "static/media/041.84925ab1.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/041.wav
 ** module id = 173
 ** module chunks = 0
 **/